import { useOutletContext } from "react-router-dom";

import type { ApiSurveyDetails } from "~/api/apiTypes";

export function useSurveyDetailData() {
  return useOutletContext<ApiSurveyDetails>();
}
